<template>
  <DialogTemplate>
    <div
      class="py-2 px-2"
      style="max-width: 620px"
    >
      <div class="text-large weight_700 clr-primary">
        {{ $t('tips.study.strategy.title') }}
      </div>
      <div class="help-grid-cont mt-4">
        <div
          v-for="item in options"
          :key="item.title"
        >
          <div class="item_title f-align-center mb-1 weight_600">
            {{ item.title }}
          </div>
          <div class="item_explanation clr-grey text-medium item_explanation_open no-events">
            <div
              v-if="item.id === 'blocker'"
              class="d-flex mb-1"
            >
              <div
                v-for="i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                :key="i"
                class="f-center f-column"
              >
                <i
                  class="mdi mdi-shield blocker-icon"
                  :style="`color: ${blockerClr(i)}`"
                ></i>
                <div class="weight_500 text-small">
                  {{ i }}
                </div>
              </div>
            </div>
            <div v-html="item.text"></div>
          </div>
        </div>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'StudyStrategyHelpDialog',
  components: {
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  methods: {
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
    blockerClr(blocker) {
      const idx = (blocker - 1) * 10
      const color = `var(--clr-eveqeqrbl${idx})`
      return color
    },
  },
  computed: {
    options() {
      let res = [
        { id: 'strategy', text_id: 'strategy' },
        { id: 'strategy_ev', text_id: 'strategy_ev' },
        { id: 'strategy_eq', text_id: 'strategy_eq' },
        { id: 'ev', text_id: 'ev' },
        { id: 'eq', text_id: 'equity' },
        { id: 'eqr', text_id: 'eqr' },
        // { id: 'blocker_tra01', text_id: 'blockers_tra01' },
        { id: 'range', text_id: 'range' },
        { id: 'overview_all', text_id: 'all' },
      ]
      res = res.map(i => {
        const r = {
          id: i.id,
          title: this.$t(`tips.study.strategy.${i.text_id}`),
          text: this.$t(`tips.study.strategy.${i.text_id}_explanation`),
        }
        return r
      })
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.help-grid-cont {
  display: grid;
  grid-gap: 1rem;
}
.item {
  &_title {
    border-radius: 4px;
    display: flex;
    align-content: center;
    transition: 0.2s;
  }
  &_explanation {
    max-height: 0;
    will-change: max-height;
    overflow: hidden;
    &_open {
      transition: max-height 0.3s ease-in-out;
      max-height: 999px;
    }
  }
}
.blocker-icon {
  font-size: 1.5rem;
  line-height: 1;
}
</style>
